import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/system/ai-config',
  component: Layout,
  redirect: '/system/ai-config/list',
  name: 'aiConfigManagement',
  meta: {
    title: 'AI配置管理',
    icon: 'i-ep:setting',
    menu: false,
  },
  children: [
    {
      path: 'list',
      name: 'aiConfigList',
      component: () => import('@/views/system/ai-config/index.vue'),
      meta: {
        title: 'AI配置管理',
        icon: 'i-ep:setting',
      },
    },
    {
      path: 'add',
      name: 'aiConfigAdd',
      component: () => import('@/views/system/ai-config/add.vue'),
      meta: {
        title: '新增AI配置',
        icon: 'i-ep:plus',
        menu: false,
      },
    },
    {
      path: 'model-prices',
      name: 'aiModelPrices',
      component: () => import('@/views/system/ai-config/model-prices.vue'),
      meta: {
        title: '模型计费版本',
        icon: 'i-ep:coin',
      },
    },
    {
      path: 'edit/:id',
      name: 'aiConfigEdit',
      component: () => import('@/views/system/ai-config/edit.vue'),
      meta: {
        title: '编辑AI配置',
        icon: 'i-ep:edit',
        menu: false,
      },
    },
  ],
}

export default routes
